<template>
    <div>
		<div class="d-flex align-items-center justify-content-between mg-b-25">
			<h3 class="df-title">Profile</h3>
		</div>

		<div class="row">
			<div class="col-6 col-sm">
				<label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Full Name</label>
				<p class="mg-b-0">{{ user.name }}</p>
			</div>
		</div>
		<div class="row">
			<div class="col-sm-4 mg-t-20 mg-sm-t-30">
				<label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Email Address</label>
				<p class="tx-primary mg-b-0">{{ user.email }}</p>
			</div>
		</div>
		<div class="row">
			<div class="col-sm-4 mg-t-20 mg-sm-t-30">
				<a href="#changePassword" data-toggle="modal" class="btn btn-sm btn-outline-default shadow-sm">
					<i data-feather="key" class="wd-10 mg-r-5"></i>  Change Password
				</a>
			</div>
		</div>

		<div class="modal" id="changePassword" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered" role="document">
				<form class="modal-content" method="POST" action="/api/user/change-password" @submit.prevent="changePassword">
					<div class="modal-header">
                        <button type="button" class="close pos-absolute t-15 r-20" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
						<h5 class="modal-title">Change Password</h5>
                    </div>
					<div class="modal-body">
						<alert-success :form="form" :class="'shadow-sm'" message="Your password has been changed!"></alert-success>

						<div class="form-group">
							<label>Current Password</label>
							<input v-model="form.current_password" type="password" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('current_password') }" name="current_password" placeholder="Enter your current password" required>
							<has-error :form="form" field="current_password"></has-error>
						</div>
						<div class="form-group">
							<label>Password</label>
							<input v-model="form.password" type="password" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('password') }" name="password" placeholder="Enter a new password" required>
							<has-error :form="form" field="password"></has-error>
						</div>
						<div class="form-group">
							<label>Confirm Password</label>
							<input v-model="form.password_confirmation " type="password" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('password_confirmation ') }" name="password_confirmation " placeholder="Enter password again" required>
							<has-error :form="form" field="password_confirmation "></has-error>
						</div>
					</div>
					<div class="modal-footer">
						<div v-if="changed" class="wd-100p">
							<button type="button" class="btn btn-primary btn-block shadow-sm" data-dismiss="modal">Close Window</button>
						</div>
						<div v-else class="change-password-buttons wd-100p">
							<button-component :busy="form.busy" :label="'Change Password'" :label-loading="'Please wait...'" :button-class="'btn btn-default shadow-sm'"></button-component>
							<button type="button" class="btn btn-primary shadow-sm" data-dismiss="modal">Cancel</button>
						</div>
					</div>
				</form>
			</div>
		</div>
    </div>
</template>

<style scoped>
	.change-password-buttons {
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}

	.change-password-buttons button:first-child {
		display: inline;
		width: initial;
	}

	.change-password-buttons button:not(:first-child) {
		margin-left: 0.25rem;
	}
</style>

<script>
	export default {
		mounted() {
			$("#changePassword").on("hidden.bs.modal", e => {
				this.changed = false;
				this.form.clear();
				this.form.reset();
			});

			feather.replace();
		},
		data() {
			return {
				changed: false,
				user: {
					name: this.$store.getters.user.name,
					email: this.$store.getters.user.email
				},
				form: new Form({
					current_password: null,
					password: null,
					password_confirmation: null
				})
			};
		},
		methods: {
			changePassword() {
				this.form.post("/api/user/change-password").then(({ data }) => {
					this.changed = true;
					this.form.reset();
				});
			}
		}
	};
</script>
